import { createRouter, createWebHistory } from "vue-router";
import Home from './components/Home';

export default createRouter({
    history : createWebHistory(),
    routes: [
        { name: "home", path: '/', component: Home },
    ],
});
